export const BUBBLE_TYPE = {
  positive: 'positive',
  veryPositive: 'veryPositive',
  neutral: 'neutral',
  negative: 'negative',
  veryNegative: 'veryNegative',
};
